import {
  SocialAuthServiceConfig,
  GoogleLoginProvider,
  GoogleInitOptions
} from "@abacritt/angularx-social-login";

// Extracted out of the giant legacy app.module.ts so the standalone bootstrap
// (app.config.ts) no longer has to import — and therefore eagerly evaluate — the
// entire app.module.ts graph (which transitively pulls pdfjs/ng2-pdf-viewer and
// other browser-only libs that crash SSR route-extraction). (#52)

const gOptions: GoogleInitOptions = {
  scopes: "https://www.googleapis.com/auth/contacts"
};

const config: SocialAuthServiceConfig = {
  providers: [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(
        "725459838767-hn8qh93m24kav98885it9vfrc61751og.apps.googleusercontent.com",
        gOptions
      )
    }
  ]
};

export function provideConfig() {
  return config;
}
